/**
 * Fix / Hacks
 * 1. Desde css Modal tiene seteado opacity: 0; para evitar "pantallazo", ahora
 *    necesitamos agregarle por js opacity: 1; y eliminárselo solo cuando se hayan
 *    terminado las animaciones, de lo contrario no se apreciarían las del closeModal.
 */

const BREAKPOINT_MOBILE = 767;
const windowWidth  = window.innerWidth || html.clientWidth || body.clientWidth;
const ShareToggle  = document.querySelector( '.header__share-toggle' );
const Modal 		 = document.querySelector( '.sharemodal' );
let ModalOverlay 	 = null;
let ModalClose 	 = null;

function Constructor() {
	if( windowWidth > BREAKPOINT_MOBILE ) return;
	if( ! Modal ) return;

	ModalOverlay = Modal.querySelector( '.sharemodal__overlay' );
	ModalClose = Modal.querySelector( '.sharemodal__close' );

	ShareToggle.addEventListener( 'click', onClick, false );
	ModalClose.addEventListener( 'click', closeModal, false );
	ModalOverlay.addEventListener( 'click', closeModal, false );
}

function onClick() {
	if( navigator.share ) {
		navigator.share({
			title: Modal.dataset.title,
			url: Modal.dataset.url,
		});
	}else{
		openModal();
	}
}

function closeModal() {
	Modal.classList.remove( 'sharemodal--open' );
	document.body.style.overflow = '';

	Modal.addEventListener( 'transitionend', function transitionEnd( e ) { /* 1 */
		e.currentTarget.removeEventListener( e.type, transitionEnd );
		Modal.style.opacity = '0';
	});
}

function openModal() {
	Modal.style.opacity = '1'; /* 1 */
	Modal.classList.add( 'sharemodal--open' );
	document.body.style.overflow = 'hidden';
}

export default Constructor;